import React, { useState, useEffect, useRef } from 'react';
import './TauriUserView.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import TauriAboutUs from '../TauriAboutUs/TauriAboutUs';
import { Modal, Button } from 'react-bootstrap';
import config from '../../appURL.json';

const TauriUserView = ({ firstName, lastName, position }) => {
    const [dropdownVisible, setDropdownVisible] = useState(false);
    const [showAboutUs, setShowAboutUs] = useState(false);
    const [showLogoutModal, setShowLogoutModal] = useState(false);
    const dropdownRef = useRef(null);

    const toggleDropdown = () => {
        setDropdownVisible(!dropdownVisible);
    };

    const handleClickOutside = (event) => {
        if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
            setDropdownVisible(false);
        }
    };

    const handleShowAboutUs = () => setShowAboutUs(true);
    const handleCloseAboutUs = () => setShowAboutUs(false);

    useEffect(() => {
        document.addEventListener('click', handleClickOutside);

        return () => {
            document.removeEventListener('click', handleClickOutside);
        };
    }, []);

    const handleLogout = (event) => {
        window.localStorage.clear();
        const currentPath = config.APP_BaseURL;
        localStorage.setItem('returnUrl', '/');
        window.location.href = `${config.API_IDENTITY_Authorize}/Identity/Account/Login?returnUrl=${encodeURIComponent(currentPath)}`;
    };

    const getInitials = (firstName, lastName) => {
        let firstInitial = '';
        let lastInitial = '';

        if (firstName) {
            const firstNameWords = firstName.split(' ');
            firstInitial = firstNameWords.length > 1 ? firstNameWords[0].charAt(0) : firstName.charAt(0);
        }

        if (lastName) {
            const lastNameWords = lastName.split(' ');
            lastInitial = lastNameWords.length > 1 ? lastNameWords[0].charAt(0) : lastName.charAt(0);
        }

        return `${firstInitial}${lastInitial}`.toUpperCase();
    };

    return (
        <div className="user-view" onClick={toggleDropdown} ref={dropdownRef}>
            <div className='user-view-details me-2'>
                <div className='circle-container'>
                    <div className="circle align-items-center">
                        <span>{getInitials(firstName || '', lastName || '')}</span>
                    </div>
                </div>
                <div className="userInfo d-none d-lg-block d-lg-flex flex-column align-items-end justify-content-center">
                    <div className="d-flex text-white">
                        <span className="userName">{firstName || ''} {lastName || ''}</span>
                    </div>
                    <hr className="horizontalLine" />
                    <div className="d-flex text-white">
                        <span className="userPosition">{position || 'NO DESIGNATION'}</span>
                    </div>
                </div>
                <div className="dropdown p-0">
                    <button className="btn dropdown-toggle" type="button" id="dropdownMenuButton" data-bs-toggle="dropdown" aria-expanded={dropdownVisible}></button>
                    <ul className={`dropdown-menu dropdown-menu-end p-0 ${dropdownVisible ? 'show' : ''}`} aria-labelledby="dropdownMenuButton">
                        <li className="mt-2">
                            <a className="dropdown-item" href="#">
                                <img src={process.env.PUBLIC_URL + "/Images/mi--switch.svg"} alt="Icon"/>
                                Switch to Company
                            </a>
                        </li>
                        <li>
                            <a className="dropdown-item" href="#">
                                <img src={process.env.PUBLIC_URL + "/Images/gg--profile.svg"} alt="Icon"/>
                                View Profile
                            </a>
                        </li>

                        <li>
                            <a className="dropdown-item" href="#">
                                <img src={process.env.PUBLIC_URL + "/Images/carbon--settings.svg"} alt="Icon"/>
                                Settings
                            </a>
                        </li>

                        <li className="d-flex align-items-center justify-content-center">
                            <hr className="m-0 mt-2" />
                        </li>

                        <li>
                            <a className="dropdown-item" onClick={handleShowAboutUs}>
                                <img src={process.env.PUBLIC_URL + "/Images/mdi--about-circle.svg"} alt="Icon"/>
                                About Us
                            </a>
                        </li>

                        <li>
                            <a className="dropdown-item" onClick={() => setShowLogoutModal(true)}>
                                <img src={process.env.PUBLIC_URL + "/Images/mdi--sign-out.svg"} alt="Icon"/>
                                Sign-Out
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
            <TauriAboutUs
                show={showAboutUs}
                onHide={handleCloseAboutUs}
            />
            <Modal show={showLogoutModal} onHide={() => setShowLogoutModal(false)} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Confirm Logout</Modal.Title>
                </Modal.Header>
                <Modal.Body>Do you really want to logout?</Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowLogoutModal(false)}>
                        Cancel
                    </Button>
                    <Button variant="primary" onClick={handleLogout}>
                        Logout
                    </Button>
                </Modal.Footer>
            </Modal>
        </div >
    );
};

export default TauriUserView;